import { cn } from '@noorden-insurtech/alba-design-system';
import {
  CheckCircle,
  ClipboardList,
  Clock,
  FileX2,
  LayoutList,
  type LucideIcon,
} from 'lucide-react';

type StatusCardConfig = {
  status: string;
  label: string;
  icon: LucideIcon;
};

// Cards agrupados. O valor de `status` pode ser uma lista de códigos
// (separados por vírgula) — ex.: Encerrada = Encerrada(2) + Expirada(4) +
// Excluída(5). O backend filtra via InConditions.StatusPortal.
const STATUS_CARDS: StatusCardConfig[] = [
  {
    status: '',
    label: 'Total de Cotações',
    icon: LayoutList,
  },
  {
    status: '1',
    label: 'Em digitação',
    icon: ClipboardList,
  },
  {
    status: '17',
    label: 'Em Análise',
    icon: Clock,
  },
  {
    status: '3',
    label: 'Calculada',
    icon: CheckCircle,
  },
  {
    status: '2,4,5',
    label: 'Encerrada',
    icon: FileX2,
  },
];

type QuoteStatusCardsProps = {
  counts: Array<{ status: string; total: number }>;
  activeStatus: string | null;
  onSelectStatus: (status: string | null) => void;
  isLoading?: boolean;
};

export function QuoteStatusCards({
  counts,
  activeStatus,
  onSelectStatus,
  isLoading,
}: QuoteStatusCardsProps) {
  const getCount = (status: string) =>
    counts.find(c => c.status === status)?.total ?? 0;

  return (
    <div className='grid w-full grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-5 lg:gap-4'>
      {STATUS_CARDS.map(card => {
        const isSelected =
          card.status === '' ? activeStatus === null : activeStatus === card.status;
        const Icon = card.icon;

        return (
          <button
            key={card.status}
            type='button'
            onClick={() => {
              if (card.status === '') {
                onSelectStatus(null);
              } else {
                onSelectStatus(isSelected ? null : card.status);
              }
            }}
            className={cn(
              'flex min-h-[102px] cursor-pointer flex-col rounded-2xl border px-3 py-3 text-left transition-all lg:min-h-[132px] lg:px-4',
              isSelected
                ? 'border-2 border-alba-green-600 bg-white shadow-sm'
                : 'border-alba-gray-200 bg-white hover:border-alba-gray-300 hover:shadow-sm'
            )}
          >
            <div className='flex items-start justify-between gap-3'>
              <div className='flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-alba-green-50 lg:h-9 lg:w-9'>
                <Icon
                  className='h-5 w-5 text-alba-green-600'
                  strokeWidth={1.6}
                />
              </div>
              <div className='flex min-h-9 items-center justify-end'>
                <span className='font-montserrat text-3xl font-bold leading-none text-alba-black-500 tabular-nums lg:text-2xl'>
                  {isLoading ? '—' : getCount(card.status)}
                </span>
              </div>
            </div>
            <span className='mt-auto font-montserrat text-xs leading-tight text-alba-gray-600 lg:text-sm'>
              {card.label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
